import {
  Component,
  OnInit,
  Inject,
  Optional,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { CROSS, RIDER, REST_LOCATION, USER_LOCATION } from 'src/defaultImages.js';
@Component({
  selector: 'app-rider-track',
  templateUrl: './rider-track.component.html',
  styleUrls: ['./rider-track.component.css'],
})
export class RiderTrackComponent implements OnInit, AfterViewInit, OnDestroy {
  images = {
    CROSS: CROSS,
    RIDER: RIDER,
    REST_LOCATION: REST_LOCATION,
    USER_LOCATION: USER_LOCATION,
  };
  riderStatus: string;
  currentOrderId: string;
  riderStatusText: string;
  foodStatusText: string;
  rider = {
    lat: null,
    lng: null,
  };
  riderIcon = this.images.RIDER;
  restIcon = this.images.REST_LOCATION;
  userIcon = this.images.USER_LOCATION;
  markerUrl = '';
  origin = {
    lat: null,
    lng: null,
  };
  destination = {
    lat: null,
    lng: null,
  };
  customer = {
    lat: null,
    lng: null,
  };

  public renderOptions = {
    suppressMarkers: true,
    polylineOptions: { strokeColor: '#4E85D5', strokeWidth: '2px' },
  };

  public markerOptions = {
    origin: {
      icon: '',
    },
    destination: {
      icon: '',
    },
  };
  lastUpdated: string;
  tracker: any;
  delivery_details: any;
  orderStatus: any;
  rest_location: any;
  showMap: boolean = false;
  riderPosition: any;
  deliveryPartner: any;
  constructor(
    public dialogRef: MatDialogRef<RiderTrackComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.customer.lat = parseFloat(this.data.customerLocation.lat);
    this.customer.lng = parseFloat(this.data.customerLocation.lng);
    this.riderStatus = this.data.deliveryDetails
      ? this.data.deliveryDetails.status
      : null;
    this.rest_location = JSON.parse(
      localStorage.getItem('restaurant_location')
    );
    this.rest_location.lat = parseFloat(this.rest_location.lat);
    this.rest_location.lon = parseFloat(this.rest_location.lon);
    this.currentOrderId = this.data.orderid;
    this.deliveryPartner = this.data.deliveryPartner;
    this.updateMarker();
    this.updateOrderStatus();
    this.tracker = setInterval(() => {
      this.updateMarker();
    }, 10000);

    this.orderStatus = setInterval(() => {
      this.updateOrderStatus();
    }, 20000);
  }

  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }

  ngAfterViewInit() {}

  updateMarker() {
    const formData: any = new FormData();
    const del_details = this.data.deliveryDetails
      ? this.data.deliveryDetails
      : {};
    const payload = {
      partner_id: del_details.partner_id
        ? del_details.partner_id
        : this.deliveryPartner,
      delivery_order_id: del_details.delivery_order_id,
      courier_id: del_details.courier_id,
    };
    this.apiService.getRiderLocation(payload).subscribe((res: any) => {
      if (res.status == 200 || res.status == 201) {
        let response = res.body.data;

        if (
          response &&
          response.latitude !== null &&
          response.longitude !== null
        ) {
          this.rider.lat = parseFloat(response.latitude);
          this.rider.lng = parseFloat(response.longitude);
        } else {
          this.updateOrderStatus();
          // this.dialogRef.close({ data: "Order Delivered Successfully" });
        }
      }
    });
    this.lastUpdated = this.formatAMPM(new Date());
  }

  updateOrderStatus() {
    this.apiService
      .getOrderDetailsNest(this.currentOrderId)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          const del_details = res.data.delivery_details
            ? res.data.delivery_details
            : {};
          this.riderStatus = del_details.status;
          this.riderPosition = del_details['courier']
            ? del_details['courier']
            : {};

          if (
            ['new', 'planned', 'ASSIGNING_DRIVER'].includes(this.riderStatus)
          ) {
            this.origin = {
              lat: this.rest_location.lat,
              lng: this.rest_location.lon,
            };
            this.destination = {
              lat: this.customer.lat,
              lng: this.customer.lng,
            };
            this.markerOptions = {
              origin: {
                icon: this.restIcon,
              },
              destination: {
                icon: this.userIcon,
              },
            };
            this.riderStatusText = 'Waiting For Driver to Confirm';
            this.foodStatusText = 'Delicious food is on the way';
          } else if (
            this.riderStatus == 'courier_assigned' ||
            this.riderStatus == 'courier_departed' ||
            this.riderStatus == 'ON_GOING'
          ) {
            if (this.rider.lat == null || this.rider.lng == null) {
              this.origin = {
                lat: parseFloat(this.riderPosition.latitude),
                lng: parseFloat(this.riderPosition.longitude),
              };
            } else this.origin = { lat: this.rider.lat, lng: this.rider.lng };
            this.destination = {
              lat: this.rest_location.lat,
              lng: this.rest_location.lon,
            };
            this.markerOptions = {
              origin: {
                icon: this.riderIcon,
              },
              destination: {
                icon: this.restIcon,
              },
            };
            this.markerUrl = this.userIcon;
            this.riderStatusText = 'Driver is on his way to Restaurant';
            this.foodStatusText = 'Delicious food is on the way';
          } else if (
            this.riderStatus == 'parcel_picked_up' ||
            this.riderStatus == 'courier_arrived' ||
            this.riderStatus == 'active' ||
            this.riderStatus == 'PICKED_UP'
          ) {
            if (this.rider.lat == null || this.rider.lng == null) {
              this.origin = {
                lat: parseFloat(this.riderPosition.latitude),
                lng: parseFloat(this.riderPosition.longitude),
              };
            } else this.origin = { lat: this.rider.lat, lng: this.rider.lng };
            this.destination = {
              lat: this.customer.lat,
              lng: this.customer.lng,
            };
            this.markerOptions = {
              origin: {
                icon: this.riderIcon,
              },
              destination: {
                icon: this.userIcon,
              },
            };
            this.markerUrl = this.restIcon;
            this.riderStatusText = 'Driver is on his way to drop your Order';
            this.foodStatusText = 'Delicious food is on the way';
          } else if (
            ['completed', 'finished', 'COMPLETED'].includes(this.riderStatus)
          ) {
            this.riderStatusText = 'Delivery Completed Successfully !';
            this.foodStatusText = '';
          } else if (
            this.riderStatus == 'canceled' ||
            this.riderStatus == 'CANCELED'
          ) {
            this.riderStatusText = 'Delivery Canceled';
            this.foodStatusText = '';
          } else if (
            this.riderStatus == 'failed' ||
            this.riderStatus == 'EXPIRED' ||
            this.riderStatus == 'REJECTED'
          ) {
            this.riderStatusText = ' Delivery failed';
            this.foodStatusText = '';
          }

          this.showMap = true;
        }
      });
  }

  formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    let strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
    return strTime;
  }

  ngOnDestroy() {
    if (this.tracker) {
      clearInterval(this.tracker);
    }
    if (this.orderStatus) {
      clearInterval(this.orderStatus);
    }
  }
}
